import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "抽中并分享后发放的会员积分", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "权重越大中签概率越高；概率 = 本权重 / 所有启用签权重之和", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted ms-2",
  style: {"font-size":"12px"}
}, "停用后不参与抽签", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.lottery_sign,
      "label-width": "120px",
      style: {"max-width":"640px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "签名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.lottery_sign.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lottery_sign.name) = $event)),
              placeholder: "如：鸿运签、上上签",
              maxlength: "20",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "签文",
          prop: "poem"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.lottery_sign.poem,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lottery_sign.poem) = $event)),
              type: "textarea",
              rows: 3,
              placeholder: "抽中该签时展示的签文",
              maxlength: "100",
              "show-word-limit": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "会员积分",
          prop: "point"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.lottery_sign.point,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lottery_sign.point) = $event)),
              min: 0,
              step: 1,
              precision: 0
            }, null, 8, ["modelValue"]),
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "权重",
          prop: "weight"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.lottery_sign.weight,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lottery_sign.weight) = $event)),
              min: 1,
              step: 1,
              precision: 0
            }, null, 8, ["modelValue"]),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "排序" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.lottery_sign.sorting,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lottery_sign.sorting) = $event)),
              min: 0,
              step: 1,
              precision: 0
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "启用" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.lottery_sign.enabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lottery_sign.enabled) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}